import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './errors';

/**
 * Серверное состояние живёт только здесь: Redux/Zustand поверх кэша запросов
 * не заводим — локального состояния в приложении почти нет.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Отказ сервера повторять бессмысленно: ни роль, ни подпись от повтора не изменятся.
        if (error instanceof ApiError) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});
